module.exports = new __parcel__URL__("toolbox.b560c410.svg").toString();